/*!
 * Main
 */

$(function () {

  // Loaded
  $('body').addClass('loaded');

  // Lazyload
  var lazyLoadInstance = new LazyLoad({
    // Your custom settings go here
  });

  // Megamenu columns
  $('.site-nav__label').each(function () {
    $(this).nextUntil('.site-nav__label').addBack().wrapAll('<div class="col"></div>');
  });

  $('.site-nav--has-submenu').mouseenter(function () {
    $('.header').addClass('megamenu--open');
  });

  $('.site-nav--has-submenu').mouseleave(function () {
    $('.header').removeClass('megamenu--open');
  });

  // Less than 1024px
  if ($(window).width() < 1024) {
    $('.header__mobile-nav ul > li.site-nav--has-submenu').append('<span class="arrow"></span>');
  }

  $(document).on('click', '.header__mobile-nav ul > li.site-nav--has-submenu span.arrow', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-open');
    $(this).prev().slideToggle();
  });


  // Hero slider
  const heroFirstSlide = document.querySelector('.hero-slide')
  const heroSlidesContainer = document.querySelector('.hero-slides')
  const heroControls = document.querySelector('.hero-controls')
  const heroPrevButton = document.querySelector('.hero-arrow-button--prev')
  const heroNextButton = document.querySelector('.hero-arrow-button--next')

  let heroCurrentSlide
  let heroPrevSlide
  let heroNextSlide

  const heroAddClasses = () => {
    heroNextSlide = heroCurrentSlide.nextElementSibling || heroSlidesContainer.firstElementChild
    heroPrevSlide = heroCurrentSlide.previousElementSibling || heroSlidesContainer.lastElementChild

    heroCurrentSlide.classList.add('hero-slide--current')
    heroPrevSlide.classList.add('hero-slide--prev')
    heroNextSlide.classList.add('hero-slide--next')
  }

  const heroRemoveClasses = () => {
    heroCurrentSlide.classList.remove('hero-slide--current')
    heroPrevSlide.classList.remove('hero-slide--prev')
    heroNextSlide.classList.remove('hero-slide--next')
  }

  const heroButtonClasses = () => {
    if (!heroCurrentSlide.nextElementSibling) {
      heroNextButton.classList.add('disabled')
    } else {
      heroNextButton.classList.remove('disabled')
    }

    if (!heroCurrentSlide.previousElementSibling) {
      heroPrevButton.classList.add('disabled')
    } else {
      heroPrevButton.classList.remove('disabled')
    }
  }

  const heroGo = (heroSlideToShow) => {
    heroRemoveClasses()
    heroCurrentSlide = heroSlideToShow
    heroButtonClasses()
    heroAddClasses()
    lazyLoadInstance.update()
  }

  if (heroSlidesContainer) {
    heroFirstSlide.classList.add('hero-slide--current')

    heroCurrentSlide = heroSlidesContainer.querySelector('.hero-slide--current')
    heroAddClasses()

    heroNextButton.addEventListener('click', () => {
      if (heroNextButton.matches('.disabled')) return
      heroGo(heroCurrentSlide.nextElementSibling || heroSlidesContainer.firstElementChild)
    })


    heroPrevButton.addEventListener('click', () => {
      if (heroPrevButton.matches('.disabled')) return
      heroGo(heroCurrentSlide.previousElementSibling || heroSlidesContainer.lastElementChild)
    })
  }


  // Featured products
  const swiper = new Swiper('.featured-products-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 25,
    speed: 700,

    autoplay: {
      delay: 5000,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.featured-products-next',
      prevEl: '.featured-products-prev',
    },

    breakpoints: {
      640: {
        loop: false,
        centeredSlides: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 30,
        autoplay: false,
      },
      992: {
        loop: false,
        centeredSlides: false,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 50,
        autoplay: false,
      }
    }
  });


  // Product usps
  const uspSwiper = new Swiper('.product-usps-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.5,
    slidesPerGroup: 1,
    spaceBetween: 25,
    speed: 700,


    breakpoints: {
      640: {
        slidesPerView: 2.3,
        slidesPerGroup: 2,
        spaceBetween: 40,
      },
      992: {
        centeredSlides: false,
        slidesPerView: 4,
        slidesPerGroup: 1,
        loop: false,
        spaceBetween: 40,
      }
    }
  });


  // Testimonial swiper
  const testimonialSwiper = new Swiper('.testimonial-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    speed: 700,
    autoHeight: true,

    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },

    // Navigation arrows
    navigation: {
      nextEl: '.testimonial-swiper-next',
      prevEl: '.testimonial-swiper-prev',
    },
  });



  // Add product to cart with ajax
  function addItemToCart(variant_id, qty) {
    var submit_text = $('[data-submit-button-text]')
    data = {
      "id": variant_id,
      "quantity": qty
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      beforeSend: function () {
        submit_text.text('Adding');
      },
      success: function (html) {
        submit_text.text('Add to cart');
        openHeaderNotice();
        console.log('Product added');
      }
    });
  }

  // open header notice
  function openHeaderNotice() {
    var header_notice = $('.header__notice');
    header_notice.addClass('header__notice--open');

    setTimeout(function () {
      header_notice.removeClass('header__notice--open');
    }, 4000);
  }

  // Add product with ajax
  // $('#addToCart').on('click', function(e) {
  //     e.preventDefault();

  //     // Set quantity and update count
  //     var variant_id = $(this).parent().parent().find('.variant_id_hidden').val();
  //     var qty = $(this).parent().parent().find('#Quantity').val();
  //     addItemToCart(variant_id, qty)

  //     var cart_count = $('.header__icons-cart span');
  //     var cart_popup_count = $('.header__cart-item-title span');

  //     var old_count = cart_count.text();
  //     var int_old_count = parseInt(old_count);
  //     var new_qty = parseInt(qty);
  //     var new_count = int_old_count + new_qty;

  //     cart_count.text(new_count);
  //     cart_popup_count.text(new_count);

  //     // Get product details
  //     var product_title = $(this).attr('data-product-title');
  //     var product_price = $(this).attr('data-product-total');
  //     var product_img = $(this).attr('data-product-image');
  //     $('.header__notice-title').text(`${product_title} has been added to your cart!`);

  //     // Add cart count if non exist
  //     if ( $('.header__icons-cart--empty').length){
  //       $('.header__icons-cart--empty').append("<span>"+new_qty+'</span>');

  //       $('.header__icons-cart').removeClass('header__icons-cart--empty');
  //     }

  //     if ( $('.header__cart-empty').length ) {
  //       document.querySelector('.header__cart-empty').innerHTML = `
  //         <div class="header__cart-item">
  //           <div class="header__cart-item-image">
  //             <img src="${product_img}" alt="${product_title}">
  //           </div>

  //           <div class="header__cart-item-content">
  //             <span class="header__cart-item-title">
  //               ${product_title} (<span>${new_qty}</span>)
  //             </span>

  //             <span class="header__cart-item-price">${product_price}</span>
  //           </div>
  //         </div>

  //         <a href="/cart" class="rounded-button rounded-button--basket">
  //           View Cart / Checkout
  //           <img src="//cdn.shopify.com/s/files/1/0302/8493/9404/t/7/assets/icon-basket.svg?v=97041414710502667321579614766" alt="basket icon">
  //         </a>
  //       `;

  //       $('.header__cart').removeClass('header__cart-empty');
  //     }
  // })

});